import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Tabs, Tab } from "@mui/material";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import { FP, PageHeader } from "components/financepro";
import { JoinGate } from "./common";
import { ConsultaCliente } from "./consultacliente";
import { DepuracionLote } from "./depuracionlote";
import { EnviarDatos } from "./enviardatos";
import { Dashboard } from "./dashboard";

const PESTANAS = [
  { label: "Depurar Cliente", icon: <PersonSearchRoundedIcon />, render: () => <ConsultaCliente /> },
  { label: "Depuración Masiva", icon: <PlaylistAddCheckRoundedIcon />, render: () => <DepuracionLote /> },
  { label: "Aportar Datos", icon: <CloudUploadRoundedIcon />, render: () => <EnviarDatos /> },
 // { label: "Panel de la Red", icon: <InsightsRoundedIcon />, render: () => <Dashboard /> },
];

export default function DataOrbit() {
  const [tab, setTab] = useState(0);

  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: FP.color.surface }}>
      <PageHeader title="DataOrbit" subtitle="Buró de crédito compartido" />
      <Box sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <JoinGate>
          <Box
            sx={{
              borderBottom: `1px solid ${FP.color.border}`,
              mb: 3,
            }}
          >
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 44,
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  minHeight: 44,
                  color: FP.color.textSecondary,
                },
                "& .Mui-selected": { color: `${FP.color.navy} !important` },
                "& .MuiTabs-indicator": { backgroundColor: FP.color.navy, height: 3, borderRadius: 3 },
              }}
            >
              {PESTANAS.map((t) => (
                <Tab key={t.label} icon={t.icon} iconPosition="start" label={t.label} />
              ))}
            </Tabs>
          </Box>

          {PESTANAS[tab].render()}
        </JoinGate>
      </Box>
    </Box>
  );
}
